export { default } from './PlayerDestacat';
